module.exports = __webpack_public_path__ + "static/media/Filter_Major_Air_xparent.aed8d3cd.png";